import { render, staticRenderFns } from "./CoSyncSettingDrawer.vue?vue&type=template&id=8249c20a&scoped=true&"
import script from "./CoSyncSettingDrawer.vue?vue&type=script&lang=ts&"
export * from "./CoSyncSettingDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncSettingDrawer.vue?vue&type=style&index=0&id=8249c20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8249c20a",
  null
  
)

export default component.exports